export class PagedResponse<T> {
	constructor(
		public items: Array<T>,
		public total: number,
	) { }
}